import { Button, Flex } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'
import { Badge } from 'components/Badge/Badge'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { IFoodHistoryDay } from 'types/foodLogistics/foodHistory.interface'
import { FOOD_STATUS_COLORS, foodHistoryMock } from '../foodData'

const historyColumns: IHonestTableColumn<IFoodHistoryDay>[] = [
  {
    id: 'date',
    header: 'Date',
    sticky: true,
    minWidth: '8rem',
    cell: (r) => <BodyText weight='600'>{r.date}</BodyText>,
  },
  {
    id: 'status',
    header: 'Status',
    cell: (r) => (
      <Badge hexColor={FOOD_STATUS_COLORS[r.status === 'Finalized' ? 'Finalized' : 'In Progress']}>
        <BodyText>{r.status}</BodyText>
      </Badge>
    ),
  },
  { id: 'breakfast', header: 'Breakfast', cell: (r) => <BodyText>{r.breakfast}</BodyText> },
  { id: 'lunch', header: 'Lunch', cell: (r) => <BodyText>{r.lunch}</BodyText> },
  { id: 'dinner', header: 'Dinner', cell: (r) => <BodyText>{r.dinner}</BodyText> },
  { id: 'nightMeal', header: 'Night Meal', cell: (r) => <BodyText>{r.nightMeal}</BodyText> },
  { id: 'exceptions', header: 'Exceptions', cell: (r) => <BodyText>{r.exceptions}</BodyText> },
  { id: 'standbyUsed', header: 'Standby Used', cell: (r) => <BodyText>{r.standbyUsed}</BodyText> },
  {
    id: 'reversals',
    header: 'Reversals',
    cell: (r) =>
      r.reversals > 0 ? (
        <Badge hexColor={FOOD_STATUS_COLORS.High}>
          <BodyText>{r.reversals} reversal</BodyText>
        </Badge>
      ) : (
        <BodyText>—</BodyText>
      ),
  },
  {
    id: 'drill',
    header: '',
    align: 'right',
    cell: () => (
      <Button orangeBorder small>
        Per-kitchen drill-down
      </Button>
    ),
  },
]

export const HistoryTab = () => {
  return (
    <Flex column gap='1rem' width='100%'>
      <Flex justend>
        <Button orange>Export</Button>
      </Flex>
      <HonestTable columns={historyColumns} data={foodHistoryMock} keyField='id' />
    </Flex>
  )
}
